import { useDispatch, useSelector } from "react-redux";
import { toggleRefresh } from "@mainaction";

// Custom hook to interact with localStorage
export const useLocalStorage = () => {
  const dispatch = useDispatch();
  const refresh = useSelector((state) => state.ForceRefresh);

  // Set data in localStorage
  const setLocalStorage = (
    key,
    value,
    expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000
  ) => {
    // 24 hours in milliseconds
    try {
      const data = {
        value: typeof value === "object" ? JSON.stringify(value) : value,
      };
      if (expirationTime) data.expiresAt = expirationTime;
      localStorage.setItem(key, JSON.stringify(data));
    } catch (error) {
      console.error(error);
    }
    dispatch(toggleRefresh(!refresh));
  };

  const getLocalStorage = (key) => {
    try {
      const data = localStorage.getItem(key);
      if (!data) return null;

      const parsedData = JSON.parse(data);
      if (parsedData?.expiresAt && Date.now() > parsedData.expiresAt) {
        localStorage.removeItem(key); // Remove expired item
        return null;
      }
      return typeof parsedData.value === "string" &&
        parsedData.value.startsWith("{")
        ? JSON.parse(parsedData.value)
        : parsedData.value;
    } catch (error) {
      return null;
    }
  };

  // Remove data from localStorage
  const removeLocalStorage = (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {}
    dispatch(toggleRefresh(!refresh));
  };

  return {
    refresh,
    setLocalStorage,
    getLocalStorage,
    removeLocalStorage,
  };
};

export const LOCAL_STORAGE = {
  USER_SOCIAL_DETAILS: "user-social-details",
  LOGIN_SCREEN: "login-screen",
  AFFILIATION_CODE: "affiliation-code",
};

export const LOGIN_SCREEN_NAME = {
  LAYOUT_SCREEN: "layout-screen",
  PAYMENT_SCREEN: "payment-screen",
  SHARE_SCREEN: "share_screen",
};
